import {
  alias,
  arrayOf as arrayOfType,
  bool as boolType,
  client,
  number as numberType,
  params,
  shape as shapeType,
  string as stringType,
} from '@thd-nucleus/data-sources';

export const pipCalculatorDataModel = {
  clientOnlyProduct: alias('product').params({
    itemId: stringType().isRequired()
  }).shape({
    dataSources: stringType(),
    // TODO: maybe we don't need this and we can keep it in buybox?
    fulfillment: client(params({ storeId: stringType() }).shape({
      fulfillmentOptions: arrayOfType(shapeType({
        type: stringType(),
        fulfillable: boolType(),
      }))
    })),
    info: shapeType({
      classNumber: stringType(),
      productDepartment: stringType(),
      pipCalculator: shapeType({
        coverageUnits: stringType(),
        display: boolType(),
        publisher: numberType(),
        toggle: stringType()
      }),
      subClassNumber: stringType()
    }),
    installServices: params({ storeId: stringType() }).shape({
      scheduleAMeasure: boolType()
    }),
    pricing: params({ storeId: stringType() }).shape({
      unitOfMeasure: stringType(),
      alternate: shapeType({
        bulk: shapeType({
          thresholdQuantity: numberType({ float: true }),
          value: numberType({ float: true })
        }),
        unit: {
          caseUnitOfMeasure: stringType()
        }
      }),
      value: numberType({ float: true })
    })
  })
};

export const samDataModel = {
  product: params({
    itemId: stringType().isRequired()
  }).shape({
    dataSources: stringType(),
    pricing: params({ storeId: stringType() }).shape({
      alternate: shapeType({
        unit: {
          unitsPerCase: stringType(),
          value: stringType()
        }
      })
    })
  })
};